export default __webpack_public_path__ + "static/media/ibrahim.a85ad2a5.jpg";